var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'component',
        'component__image',
        _vm.fullHeight ? 'component__image--fullheight' : '',
        _vm.clickable ? 'component__image--clickable' : ''
    ],on:{"click":_vm.emitClick}},[_c('img',{style:(_vm.height ? ("height: " + _vm.height + "px") : ''),attrs:{"src":_vm.outputUrl,"alt":_vm.alt,"onerror":"this.style.display='none'"}})])}
var staticRenderFns = []

export { render, staticRenderFns }